import { IAuditable } from './auditable';
import { SubmissionBase, TestSubmissionModel } from './submission';
import { Test } from './tests';

export const EXAM_TYPE = {
  TEST: 'TEST',
  EXERCISE: 'EXERCISE',
};

export type Examination = {
  id: string;
  title: string;
  duration: number;
  type: string;
  description: string;
  test: Test;
  createdAt: string;
  testSubmissions: SubmissionBase[];
};

export type ExamModel = {
  id: string;
  title: string;
  description: string;
  type: string;
  classId: number;
  duration: number;
  dueDate?: Date;
  createdAt: Date;
  testSubmissions: TestSubmissionModel[];
  test: Test;
} & StatisticExam &
  IAuditable;

export type StatisticExam = {
  totalQuestion: number;
  totalPoint: number;
  totalDuration: number;
};
